/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import Loader from "../../Components/Loader";
import { authActionCreators, dataActionCreators } from "../../services/Actions";
import Modal from "../Components/Modal";
import PromptModal from "../Components/PromptModal";
import "../css/pages.css";
import RenderAdminPage from "../RenderAdminPage";
import "./SystemUsers.css";

const rolesValues = [
  "ADMIN",
  "LOAN_OFFICER",
  "LOAN_OFFICER_AUTHORIZER",
  "LOAN_OFFICER_HEAD",
  "MART_OFFICER",
  "MART_OFFICER_HEAD",
  "UNION_USER",
  "INVESTMENT",
  "INVESTMENT_HEAD",
  "IT_OFFICER",
];

const roleLabels = {
  ADMIN: "Admin",
  LOAN_OFFICER: "Loan Officer",
  LOAN_OFFICER_AUTHORIZER: "Loan Auth.",
  LOAN_OFFICER_HEAD: "Loan Head",
  MART_OFFICER: "Mart Officer",
  MART_OFFICER_HEAD: "Mart Head",
  UNION_USER: "Union User",
  INVESTMENT: "Investment",
  INVESTMENT_HEAD: "Investment Head",
  IT_OFFICER: "IT Officer",
};

const roleBadgeColors = {
  ADMIN: "bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300",
  LOAN_OFFICER: "bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300",
  LOAN_OFFICER_AUTHORIZER: "bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300",
  LOAN_OFFICER_HEAD: "bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300",
  MART_OFFICER: "bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300",
  MART_OFFICER_HEAD: "bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300",
  UNION_USER: "bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300",
  INVESTMENT: "bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300",
  INVESTMENT_HEAD: "bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300",
  IT_OFFICER: "bg-cyan-100 dark:bg-cyan-900/30 text-cyan-700 dark:text-cyan-300",
};

const superRoleBadgeColors = {
  ADMIN: "bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 border border-purple-200 dark:border-purple-800",
  LOAN_OFFICER: "bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800",
  MART_OFFICER: "bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800",
  UNION_USER: "bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 border border-amber-200 dark:border-amber-800",
  INVESTMENT_OFFICER: "bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300 border border-orange-200 dark:border-orange-800",
  IT_OFFICER: "bg-cyan-100 dark:bg-cyan-900/30 text-cyan-700 dark:text-cyan-300 border border-cyan-200 dark:border-cyan-800",
};

const inputCls =
  "w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all placeholder:text-slate-400 dark:placeholder:text-slate-500";
const labelCls = "block mb-1.5 text-sm font-medium text-slate-700 dark:text-slate-300";

function RoleChips({ values, selected, onChange }) {
  const toggle = (rol) => {
    if (selected?.includes(rol)) {
      onChange(selected.filter((r) => r !== rol));
    } else {
      onChange([...(selected || []), rol]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {values.map((rol) => {
        const active = selected?.includes(rol);
        return (
          <button
            key={rol}
            type="button"
            onClick={() => toggle(rol)}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-all select-none ${
              active
                ? "bg-indigo-600 border-indigo-600 text-white shadow-sm"
                : "bg-white dark:bg-gray-800 border-slate-200 dark:border-gray-600 text-slate-600 dark:text-slate-300 hover:border-indigo-400 hover:text-indigo-600 dark:hover:text-indigo-400"
            }`}
          >
            {active && (
              <svg className="w-3 h-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            )}
            {roleLabels[rol] || rol}
          </button>
        );
      })}
    </div>
  );
}

function SystemUsers() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { GetSystemUsers } = bindActionCreators(dataActionCreators, dispatch);
  const { AddNewSystemUser, ResetAuthResponse, DeleteSystemUser, EditSystemUser } =
    bindActionCreators(authActionCreators, dispatch);
  const data = useSelector((state) => state.data);
  const auth = useSelector((state) => state.auth);

  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openPromptModal, setPromptOpenModal] = useState(false);

  const initialFormData = {
    name: "",
    email: "",
    staff_code: "",
    phone_number: "",
    password: "",
    super_role: "ADMIN",
    title: "Mr.",
    officer: "",
  };

  const initialFormEditData = {
    name: "",
    email: "",
    staff_code: "",
    phone_number: "",
    officer: "",
    super_role: "ADMIN",
    password: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [formEditData, setFormEditData] = useState(initialFormEditData);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedEditUserRoles, setSelectedEditUserRoles] = useState([]);
  const [seletedUserData, setSelectedUserData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormEditChange = (e) => {
    const { name, value } = e.target;
    setFormEditData({ ...formEditData, [name]: value });
  };

  const handleModalSubmit = (e) => {
    e?.preventDefault();
    const newName = `${formData.title} ${formData.name}`;
    if (formData?.name) {
      AddNewSystemUser({
        ...formData,
        name: newName,
        user_type: "SYSTEM_USER",
        role: selectedRoles,
        staff_id: formData.staff_code,
      });
      setFormData(initialFormData);
      setSelectedRoles([]);
      setOpenModal(false);
    }
  };

  const handleEditModalSubmit = (e, user) => {
    e.preventDefault();
    EditSystemUser(user, { ...formEditData, role: selectedEditUserRoles });
    setOpenEditModal(false);
  };

  useEffect(() => {
    setFormEditData({
      name: seletedUserData?.name || "",
      email: seletedUserData?.email || "",
      phone_number: seletedUserData?.phone_number || "",
      staff_code: seletedUserData?.staff_code || "",
      officer: seletedUserData?.officer || "",
      super_role: seletedUserData?.super_role || "ADMIN",
      password: "",
    });
    setSelectedEditUserRoles(seletedUserData?.role || []);
  }, [seletedUserData]);

  useEffect(() => {
    GetSystemUsers();
  }, []);

  useEffect(() => {
    if (auth?.response?.state === "SUCCESS") {
      toast.success(auth?.response?.message);
      setTimeout(() => {
        ResetAuthResponse();
        GetSystemUsers();
      }, 1500);
    } else if (auth?.response?.state === "ERROR") {
      toast.error(auth?.response?.message);
      setTimeout(() => ResetAuthResponse(), 1500);
    }
  }, [auth?.response?.state, auth?.response?.message]);

  return (
    <div>
      <RenderAdminPage title="System Users">
        {auth.isLoading && <Loader />}

        {/* Toolbar */}
        <div className="flex flex-col sm:flex-row gap-3 mb-6">
          <div className="flex-1">
            <label htmlFor="search" className={labelCls}>Search</label>
            <input
              type="search"
              id="search"
              placeholder="Search by staff ID, name..."
              className={inputCls}
            />
          </div>
          <div className="w-full sm:w-40">
            <label htmlFor="limit" className={labelCls}>Show</label>
            <select className={inputCls}>
              {[15, 25, 30, 50, 100, 200, 250].map((n) => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex items-center justify-between mb-4">
          <p className="text-sm text-slate-500 dark:text-slate-400">
            {data?.system_users?.length || 0} users
          </p>
          <button
            className="px-4 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-colors shadow-sm"
            onClick={() => setOpenModal(true)}
          >
            + Add Member
          </button>
        </div>

        {/* Table */}
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 dark:bg-gray-700/50">
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Name</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Email</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Phone</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Roles</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Main Role</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-gray-700">
                {data?.system_users?.length > 0 ? (
                  data.system_users.map((user, index) => (
                    <tr key={index} className="hover:bg-slate-50 dark:hover:bg-gray-700/30 transition-colors">
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-3">
                          <img
                            className="w-9 h-9 rounded-full object-cover ring-2 ring-slate-100 dark:ring-gray-700"
                            src={user?.profile_image || (user?.name?.split(" ")[0] === "Mr." ? "/images/dev/avarta2.jpeg" : "/images/dev/woman-avarta.jpeg")}
                            alt=""
                          />
                          <div>
                            <p className="text-sm font-semibold text-slate-800 dark:text-slate-200">{user?.name}</p>
                            <p className="text-xs text-slate-400 dark:text-slate-500 font-mono">{user?.staff_code}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-slate-600 dark:text-slate-300">{user?.email || "—"}</td>
                      <td className="px-4 py-3 text-sm text-slate-600 dark:text-slate-300">{user?.phone_number || "—"}</td>
                      <td className="px-4 py-3">
                        <div className="flex flex-wrap gap-1">
                          {user?.role?.map((rol, i) => (
                            <span
                              key={i}
                              className={`inline-flex px-2 py-0.5 rounded-full text-xs font-semibold ${roleBadgeColors[rol] || "bg-slate-100 dark:bg-gray-700 text-slate-600 dark:text-slate-300"}`}
                            >
                              {roleLabels[rol] || rol}
                            </span>
                          ))}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-bold ${superRoleBadgeColors[user?.super_role] || "bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 border border-indigo-200"}`}>
                          {roleLabels[user?.super_role] || user?.super_role}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-right">
                        <div className="flex items-center justify-end gap-2">
                          <button
                            type="button"
                            title="Edit"
                            className="p-1.5 rounded-lg text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 dark:hover:bg-indigo-900/20 dark:hover:text-indigo-400 transition-colors"
                            onClick={() => { setOpenEditModal(true); setSelectedUserData(user); }}
                          >
                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                            </svg>
                          </button>
                          <button
                            type="button"
                            title="Delete"
                            className="p-1.5 rounded-lg text-slate-400 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 dark:hover:text-red-400 transition-colors"
                            onClick={() => { setPromptOpenModal(true); setSelectedUserData(user); }}
                          >
                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="px-4 py-14 text-center text-sm text-slate-400 dark:text-slate-500">
                      No system users found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── ADD MEMBER MODAL ── */}
        {openModal && (
          <Modal closeModal={setOpenModal} title="Add System User" width="560px">
            <form onSubmit={handleModalSubmit} className="space-y-4">

              {/* Title + Full Name */}
              <div className="flex gap-3">
                <div className="w-28 flex-shrink-0">
                  <label className={labelCls}>Title</label>
                  <select name="title" value={formData.title} onChange={handleChange} className={inputCls}>
                    <option value="Mr.">Mr.</option>
                    <option value="Miss">Miss</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Dr.">Dr.</option>
                  </select>
                </div>
                <div className="flex-1">
                  <label className={labelCls}>Full Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="e.g. Kofi Mensah"
                    required
                    className={inputCls}
                  />
                </div>
              </div>

              {/* Staff Code + Officer */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelCls}>Staff Code</label>
                  <input
                    type="text"
                    name="staff_code"
                    value={formData.staff_code}
                    onChange={handleChange}
                    placeholder="e.g. UPNMG-001"
                    required
                    className={inputCls}
                  />
                </div>
                <div>
                  <label className={labelCls}>Officer Title</label>
                  <input
                    type="text"
                    name="officer"
                    value={formData.officer}
                    onChange={handleChange}
                    placeholder="e.g. North Loan Officer"
                    className={inputCls}
                  />
                </div>
              </div>

              {/* Email + Phone */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelCls}>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="example@upnmg.org"
                    className={inputCls}
                  />
                </div>
                <div>
                  <label className={labelCls}>Phone Number</label>
                  <input
                    type="tel"
                    name="phone_number"
                    value={formData.phone_number}
                    onChange={handleChange}
                    placeholder="0XX XXX XXXX"
                    className={inputCls}
                  />
                </div>
              </div>

              {/* Main Role + Password */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelCls}>Main Role</label>
                  <select name="super_role" value={formData.super_role} onChange={handleChange} className={inputCls}>
                    <option value="ADMIN">Admin</option>
                    <option value="LOAN_OFFICER">Loan Officer</option>
                    <option value="MART_OFFICER">Mart Officer</option>
                    <option value="UNION_USER">Union User</option>
                    <option value="INVESTMENT_OFFICER">Investment Officer</option>
                    <option value="IT_OFFICER">IT Officer</option>
                  </select>
                </div>
                <div>
                  <label className={labelCls}>Default Password</label>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    className={inputCls}
                  />
                </div>
              </div>

              {/* Roles / Permissions */}
              <div>
                <label className={labelCls}>
                  Add Roles
                  <span className="ml-1 text-xs font-normal text-slate-400">(who can manage)</span>
                </label>
                {selectedRoles.length > 0 && (
                  <p className="text-xs text-indigo-600 dark:text-indigo-400 mb-1.5 font-medium">
                    {selectedRoles.length} role{selectedRoles.length > 1 ? "s" : ""} selected
                  </p>
                )}
                <div className="p-3 rounded-xl border border-slate-200 dark:border-gray-600 bg-slate-50/50 dark:bg-gray-800/50">
                  <RoleChips values={rolesValues} selected={selectedRoles} onChange={setSelectedRoles} />
                </div>
              </div>

              {/* Actions */}
              <div className="flex items-center justify-end gap-3 pt-2 border-t border-slate-100 dark:border-gray-700">
                <button
                  type="button"
                  onClick={() => setOpenModal(false)}
                  className="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 text-slate-600 dark:text-slate-300 text-sm font-medium hover:bg-slate-50 dark:hover:bg-gray-700 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-5 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-colors shadow-sm"
                >
                  Add User
                </button>
              </div>
            </form>
          </Modal>
        )}

        {/* ── EDIT MEMBER MODAL ── */}
        {openEditModal && (
          <Modal closeModal={setOpenEditModal} title="Edit System User" width="560px">
            <form onSubmit={(e) => handleEditModalSubmit(e, seletedUserData?._id)} autoComplete="off" className="space-y-4">

              {/* Full Name */}
              <div>
                <label className={labelCls}>Full Name</label>
                <input
                  type="text"
                  name="name"
                  defaultValue={seletedUserData?.name}
                  onChange={handleFormEditChange}
                  placeholder="Full name"
                  className={inputCls}
                />
              </div>

              {/* Staff Code + Officer */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelCls}>Staff Code</label>
                  <input
                    type="text"
                    name="staff_code"
                    defaultValue={seletedUserData?.staff_code}
                    onChange={handleFormEditChange}
                    className={inputCls}
                  />
                </div>
                <div>
                  <label className={labelCls}>Officer Title</label>
                  <input
                    type="text"
                    name="officer"
                    defaultValue={seletedUserData?.officer}
                    onChange={handleFormEditChange}
                    placeholder="e.g. North Loan Officer"
                    className={inputCls}
                  />
                </div>
              </div>

              {/* Email + Phone */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelCls}>Email</label>
                  <input
                    type="email"
                    name="email"
                    defaultValue={seletedUserData?.email}
                    onChange={handleFormEditChange}
                    placeholder="example@upnmg.org"
                    className={inputCls}
                  />
                </div>
                <div>
                  <label className={labelCls}>Phone Number</label>
                  <input
                    type="tel"
                    name="phone_number"
                    defaultValue={seletedUserData?.phone_number}
                    onChange={handleFormEditChange}
                    className={inputCls}
                  />
                </div>
              </div>

              {/* Main Role + Password */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelCls}>Main Role</label>
                  <select
                    name="super_role"
                    value={formEditData.super_role}
                    onChange={handleFormEditChange}
                    className={inputCls}
                  >
                    <option value="ADMIN">Admin</option>
                    <option value="LOAN_OFFICER">Loan Officer</option>
                    <option value="MART_OFFICER">Mart Officer</option>
                    <option value="UNION_USER">Union User</option>
                    <option value="INVESTMENT_OFFICER">Investment Officer</option>
                    <option value="IT_OFFICER">IT Officer</option>
                  </select>
                </div>
                <div>
                  <label className={labelCls}>
                    New Password
                    <span className="ml-1 text-xs font-normal text-slate-400">(leave blank to keep)</span>
                  </label>
                  <input
                    type="password"
                    name="password"
                    onChange={handleFormEditChange}
                    autoComplete="new-password"
                    className={inputCls}
                  />
                </div>
              </div>

              {/* Roles / Permissions */}
              <div>
                <label className={labelCls}>
                  Add Roles
                  <span className="ml-1 text-xs font-normal text-slate-400">(who can manage)</span>
                </label>
                {selectedEditUserRoles?.length > 0 && (
                  <p className="text-xs text-indigo-600 dark:text-indigo-400 mb-1.5 font-medium">
                    {selectedEditUserRoles.length} role{selectedEditUserRoles.length > 1 ? "s" : ""} selected
                  </p>
                )}
                <div className="p-3 rounded-xl border border-slate-200 dark:border-gray-600 bg-slate-50/50 dark:bg-gray-800/50">
                  <RoleChips values={rolesValues} selected={selectedEditUserRoles} onChange={setSelectedEditUserRoles} />
                </div>
              </div>

              {/* Actions */}
              <div className="flex items-center justify-end gap-3 pt-2 border-t border-slate-100 dark:border-gray-700">
                <button
                  type="button"
                  onClick={() => setOpenEditModal(false)}
                  className="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 text-slate-600 dark:text-slate-300 text-sm font-medium hover:bg-slate-50 dark:hover:bg-gray-700 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-5 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold transition-colors shadow-sm"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </Modal>
        )}

        {/* ── DELETE CONFIRM MODAL ── */}
        {openPromptModal && (
          <PromptModal closeModal={setPromptOpenModal} width="auto">
            <div className="p-6 text-center">
              <div className="w-14 h-14 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mx-auto mb-4">
                <svg className="w-7 h-7 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-slate-800 dark:text-slate-100 mb-1">Delete User</h3>
              <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
                Are you sure you want to delete{" "}
                <span className="font-semibold text-slate-700 dark:text-slate-300">{seletedUserData?.name}</span>?
                This action cannot be undone.
              </p>
              <div className="flex items-center justify-center gap-3">
                <button
                  type="button"
                  onClick={() => setPromptOpenModal(false)}
                  className="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 text-slate-600 dark:text-slate-300 text-sm font-medium hover:bg-slate-50 dark:hover:bg-gray-700 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={() => {
                    DeleteSystemUser(seletedUserData?.staff_code);
                    setPromptOpenModal(false);
                  }}
                  className="px-5 py-2.5 rounded-xl bg-red-600 hover:bg-red-700 text-white text-sm font-semibold transition-colors shadow-sm"
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </PromptModal>
        )}

        <ToastContainer autoClose={3000} />
      </RenderAdminPage>
    </div>
  );
}

export default SystemUsers;
